import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectEffectiveValues } from '@hkm/components/Menu/PropertySelector/domain/selectors';
import { GuestServiceStatusType } from '@hkm/shared/enum/guestServiceStatusType';

export function useGuestServiceMap(): Map<GuestServiceStatusType, boolean> {
  const effectiveValues = useSelector(selectEffectiveValues)!;

  return useMemo(
    () =>
      new Map<GuestServiceStatusType, boolean>([
        [
          GuestServiceStatusType.ServiceDeferred,
          effectiveValues.guestServiceStatusServiceDeferred
        ],
        [
          GuestServiceStatusType.DoNotDisturb,
          effectiveValues.guestServiceStatusDoNotDisturbed
        ],
        [
          GuestServiceStatusType.ServiceRefused,
          effectiveValues.guestServiceStatusServiceRefused
        ],
        [
          GuestServiceStatusType.ServiceRequested,
          effectiveValues.guestServiceStatusServiceRequested
        ]
      ]),
    [effectiveValues]
  );
}



// WEBPACK FOOTER //
// ./src/shared/hooks/useGuestServiceMap.ts